// canvasSlice.js

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  activeCanvas: null, // initially no canvas
  lastFileHandle: null,  // file handle for Save/Save As
};

const canvasSlice = createSlice({
  name: 'canvas',
  initialState,
  reducers: {
    setActiveCanvas: (state, action) => {
        console.log("setActiveCanvas: ",state, action.payload)
      state.activeCanvas = action.payload; 
    },
    setLastFileHandle: (state, action) => {
      console.log("setLastFileHandle: ", action.payload);
      state.lastFileHandle = action.payload;
    },
    clearCanvasState: (state) => {
      state.activeCanvas = null;
      state.lastFileHandle = null;
    },
  },
});

export const { setActiveCanvas, setLastFileHandle, clearCanvasState } = canvasSlice.actions;

export default canvasSlice.reducer;
